import { Link } from "react-router-dom";
import { Newsletter, Marquee, useFadeUp } from "../components";
import { POSTS, MARQUEE_ITEMS } from "../data/content";

const VIDEOS = [
  {
    id: 1,
    title: "I Got Fined $97 on the Tram - My First Week in Melbourne",
    views: "",
    age: "",
    gradient: "linear-gradient(135deg, #C8742A, #9B3A1A)",
    youtubeId: "lX2haOkf-g8",
    isShort: true,
  },
  {
    id: 2,
    title: "POV: Your Office is on the 38th Floor in Melbourne",
    views: "",
    age: "",
    gradient: "linear-gradient(135deg, #4A7FA5, #2d5a7a)",
    youtubeId: "GXVrVVze0CE",
    isShort: true,
  },
  {
    id: 3,
    title: "Australia Through My Lens",
    views: "",
    age: "",
    gradient: "linear-gradient(135deg, #6B8C6A, #3d5c3d)",
    youtubeId: "VxrHYlBHZsw",
    isShort: true,
  },
  {
    id: 4,
    title: "Melbourne F1 Weekend: I Tried Driving an F1 Car 😳",
    views: "",
    age: "",
    gradient: "linear-gradient(135deg, #C8742A, #6B3010)",
    youtubeId: "fMkiGSK3KwQ",
    isShort: false,
  },
];

export default function Home() {
  const aboutRef = useFadeUp();
  const ytRef = useFadeUp();

  const featured = POSTS.find(p => p.featured);
  const rest = POSTS.filter(p => !p.featured).slice(0, 4);

  return (
    <div className="page">
      {/* HERO */}
      <section className="hero">
        <div className="hero-left">
          <div className="hero-eyebrow">Melbourne, Australia · Est. 2022</div>
          <h1 className="hero-title">Life<br /><em>Down</em><br />Under</h1>
          <p className="hero-subtitle">
            Student. Grad. PR applicant. My raw, unfiltered journey of building
            a life in Australia - one visa, one suburb, one sunrise at a time.
          </p>
          <div className="hero-actions">
            <Link to="/blog" className="btn-primary">
              Read the stories
              <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
            <Link to="/guides" className="btn-secondary">Free guides ↓</Link>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-image-bg" />
          <svg className="hero-aus-map" viewBox="0 0 400 350" xmlns="http://www.w3.org/2000/svg">
            <path d="M60,80 L80,60 L120,50 L160,45 L200,50 L240,60 L270,80 L295,110 L310,140 L320,170 L325,200 L320,230 L305,255 L280,275 L255,285 L230,285 L210,275 L195,260 L185,245 L175,255 L160,275 L145,280 L130,275 L120,260 L115,240 L120,215 L110,210 L95,215 L80,205 L70,185 L65,160 L60,140 L55,115 Z M350,60 L365,65 L375,80 L370,95 L355,95 L345,80 L345,68 Z" />
          </svg>
          <div className="hero-tags">
            {["Student Visa → PR Journey", "Melbourne Life & Culture", "Free Guides & Downloads"].map(t => (
              <div className="hero-tag" key={t}><span className="tag-dot" />{t}</div>
            ))}
          </div>
        </div>
      </section>

      {/* MARQUEE */}
      <Marquee items={MARQUEE_ITEMS} />

      {/* STATS */}
      <div className="stats-strip">
        {[
          { num: "8+", label: "Years in Aus" },
          { num: "20+", label: "Videos" },
          { num: "8+", label: "Free Guides" },
          { num: "∞", label: "Flat Whites" },
        ].map(({ num, label }) => (
          <div className="stat-card" key={label}>
            <div className="stat-number">{num}</div>
            <div className="stat-label">{label}</div>
          </div>
        ))}
      </div>

      {/* FEATURED POSTS */}
      <section className="section">
        <div className="section-header">
          <h2 className="section-title">Latest Stories</h2>
          <Link to="/blog" className="section-link">All posts →</Link>
        </div>
        <div className="featured-grid">
          {featured && (
            <Link to={`/blog/${featured.slug}`} className="post-card featured">
              <div className="post-card-num">{featured.num || "01"}</div>
              <div>
                <div className="post-category">{featured.category}</div>
                <h3 className="post-title">{featured.title}</h3>
                <p className="post-excerpt">{featured.excerpt}</p>
                <div className="post-meta">
                  <span>{featured.date}</span><span className="meta-dot" /><span>{featured.readTime}</span>
                </div>
              </div>
            </Link>
          )}
          {rest.map((post, i) => (
            <Link to={`/blog/${post.slug}`} className="post-card" key={post.id}>
              <div className="post-card-num">{post.num || `0${i + 2}`}</div>
              <div className="post-category">{post.category}</div>
              <h3 className="post-title">{post.title}</h3>
              <p className="post-excerpt">{post.excerpt}</p>
              <div className="post-meta">
                <span>{post.date}</span><span className="meta-dot" /><span>{post.readTime}</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* ABOUT */}
      <div className="about-strip">
        <div className="about-left">
          <div className="about-left-label">About the creator</div>
          <div className="about-avatar">SJ</div>
          <div className="about-name">SJ</div>
          <div className="about-handle">@sj_downunder</div>
        </div>
        <div className="about-right fade-up" ref={aboutRef}>
          <p className="about-text">
            I moved to Australia as an international student with one suitcase and a lot of questions.
            Now I document everything - the <strong>beautiful, the bureaucratic, and the bizarre</strong> -
            for anyone walking the same path. This blog is the written companion to my YouTube channel.
          </p>
          <div className="about-stats">
            {[["8+","Years in Aus"],["20+","Videos"],["Free guides"]].map(([n, l]) => (
              <div key={l}>
                <div className="about-stat-number">{n}</div>
                <div className="about-stat-label">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* YOUTUBE */}
      <section className="yt-section">
        <div className="fade-up" ref={ytRef}>
          <div className="yt-eyebrow">
            <svg width="18" height="13" viewBox="0 0 20 14" fill="#FF0000">
              <path d="M19.6 2.2a2.5 2.5 0 0 0-1.75-1.77C16.25 0 10 0 10 0S3.75 0 2.15.43A2.5 2.5 0 0 0 .4 2.2 26.2 26.2 0 0 0 0 7a26.2 26.2 0 0 0 .4 4.8 2.5 2.5 0 0 0 1.75 1.77C3.75 14 10 14 10 14s6.25 0 7.85-.43a2.5 2.5 0 0 0 1.75-1.77A26.2 26.2 0 0 0 20 7a26.2 26.2 0 0 0-.4-4.8z" />
              <polygon fill="white" points="8,10 13,7 8,4" />
            </svg>
            YouTube Channel
          </div>
          <h2 className="yt-title">Watch the<br /><em>journey</em><br />unfold</h2>
          <p className="yt-text">
            Blog posts are my long thoughts. The vlogs are where you feel what it's actually like to be here.
          </p>
          <a href="https://www.youtube.com/@saketdownunder" target="_blank" rel="noopener noreferrer" className="yt-btn">
            Subscribe on YouTube
          </a>
        </div>
        <div className="yt-list">
  {VIDEOS.map(v => (
    <div
      className="yt-card"
      key={v.id}
      onClick={() => v.youtubeId && window.open(
        v.isShort
          ? `https://youtube.com/shorts/${v.youtubeId}`
          : `https://youtube.com/watch?v=${v.youtubeId}`,
        "_blank"
      )}
      style={{ cursor: v.youtubeId ? "pointer" : "default" }}
    >
      <div className="yt-thumb" style={{ background: v.gradient, overflow: "hidden", padding: 0 }}>
        {v.youtubeId
          ? <img
              src={`https://img.youtube.com/vi/${v.youtubeId}/mqdefault.jpg`}
              alt={v.title}
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
          : <div className="play-icon" />
        }
      </div>
      <div>
        <div className="yt-video-title">{v.title}</div>
        {v.views && <div className="yt-video-meta">{v.views} · {v.age}</div>}
      </div>
    </div>
  ))}
</div>
      </section>

      <Newsletter />
    </div>
  );
}
